import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { RegistrationMode } from '~/engine/tool/tools/RegistrationTool';
import {
    registrationModeState,
    selectedToolState,
} from '~/state/atoms/toolsAtoms';
import { OverlayLabel, OverlayRow } from '~/components/OverlayLabel';

const isMac = navigator.platform.toUpperCase().includes('MAC');
const modifierKey = isMac ? 'Cmd' : 'Ctrl';

/**
 * The keys that nudge the registration, while the registration tool is
 * selected in a mode the keys act in: translate or rotate. VOI mode has no
 * nudge, so it shows nothing. The mount shows it only in the registration
 * step.
 */
const RegistrationShortcutHints = () => {
    const intl = useIntl();
    const tool = useRecoilValue(selectedToolState);
    const registrationMode = useRecoilValue(registrationModeState);

    const isTranslation =
        registrationMode.mode === RegistrationMode.TRANSLATION;
    const isRotation = registrationMode.mode === RegistrationMode.ROTATION;

    if (tool !== 'registration' || (!isTranslation && !isRotation)) {
        return null;
    }

    const hint = intl.formatMessage(
        { id: 'registration.shortcutHint' },
        {
            modifier: modifierKey,
            mode: isTranslation ? 'translate' : 'rotate',
        }
    );

    return (
        <OverlayRow
            data-testid="registration-shortcut-hint"
            sx={{ alignItems: 'center', px: 0.5, ml: -0.5 }}
        >
            <OverlayLabel>{hint}</OverlayLabel>
        </OverlayRow>
    );
};

export default RegistrationShortcutHints;
